module.exports = __webpack_public_path__ + "static/media/icon-file-download.c3ecd33f.svg";